(ns arthur.footage.store
  "Clips loaded at RUNTIME live outside app-db. The db keeps only their id.

  Two things arrive this way and they are the same kind of thing: footage that has
  been detected and frozen, and a project opened from the server. Both are
  `{:clip ... :store ...}` — which is what `flow/freeze` returns — plus what the
  transport reads off the clip, and both hold typed arrays that have no business
  being in a map every mounted subscription compares."
  (:require [arthur.db :as db]))

(defonce ^:private loaded (atom nil))
(defonce ^:private serial (atom 0))

(defn install!
  "Hold one loaded clip, and hand back the id app-db will refer to it by.

  ONE AT A TIME, on purpose: a second loaded clip is a second megabyte-scale store
  with nothing to evict it, and the timeline that would want several is out of
  scope. `kind` only names the id — `:footage/3`, `:project/4` — so that a clip's
  origin is legible in the db without a lookup."
  [entry kind]
  (let [id (keyword kind (str (swap! serial inc)))]
    (when-let [old (:audio @loaded)]
      (when (and (not= old (:audio entry)) (.startsWith old "blob:"))
        (js/URL.revokeObjectURL old)))
    (reset! loaded (assoc entry :id id))
    id))

(defn entry [id]
  (if (= id (:id @loaded))
    @loaded
    (db/clip-entry id)))

(defn edit-entry!
  "Edit the loaded entry — the document and what travels with it: its blocks,
  its footage, its retained source tracks. Built-in clips are copied into the
  runtime store on first edit, so their delayed source values remain reusable."
  [id f]
  (if (= id (:id @loaded))
    (do (swap! loaded f) id)
    (when-let [entry (entry id)]
      (install! (f entry) "paint"))))

(defn edit-clip!
  "Edit the loaded document and nothing beside it."
  [id f]
  (edit-entry! id #(update % :clip f)))
